const FEATURES = {
  SHOP: {
    ID: '', // Will be determined in the future
    NAME: 'shop',
  },
  SHOP_HARDWARE_FLOW: {
    // See https://docs.google.com/spreadsheets/d/1n5PvCFwxjMvjOdHviRiVnqcG06cW0FOLVnjZy4ckWwg/ for more info.
    ID: '0ace5628-372d-43e0-8c53-7601694b5d6f',
    NAME: 'Shop hardware flow',
  },
};

const COMPONENT_NAMES = {
  APPS: {
    CART: {
      YOUR_CART: 'Your Cart',
      RECOMMENDED_FOR_YOU: 'Recommended for you',
    },
    CHECKOUT: {
      CONTACT_AND_SHIPPING: 'Checkout - Contact & Shipping',
      SHIPPING_SELECTION: 'Checkout - Shipping selection',
      FINANCING_OFFERS: 'Checkout - Financing offers',
      PAYMENT_METHOD: 'Checkout - Payment method',
      FINANCING_APPLICATION: 'Checkout - Financing Application',
      PAYMENT_INFO: 'Checkout - Complete payment info',
      REVIEW: 'Checkout - Review',
      ORDER_COMPLETE: 'Checkout - Order Complete',
    },
    DASHBOARD_MODE: {
      HEADER: 'Dashboard Mode - Header',
    },
  },
};

export { COMPONENT_NAMES, FEATURES };
